module.exports = __webpack_public_path__ + "static/mentor-amit-c85e5ddc2e04ef24c78a75aac2c200a8.png";